import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "singleBtn",
    "rangeBtn",
    "dateType",
    "singleContainer",
    "rangeContainer",
    "singleDate",
    "startDate",
    "endDate",
    "calendarType",
    "hiddenDates"
  ]

  connect() {
    this.selectSingle()
  }

  selectSingle(e) {
    if (e) e.preventDefault()
    
    this.singleBtnTarget.classList.add("active")
    this.rangeBtnTarget.classList.remove("active")
    
    this.dateTypeTarget.value = "single"
    this.singleContainerTarget.classList.remove("d-none")
    this.rangeContainerTarget.classList.add("d-none")
    
    this.singleDateTarget.required = true
    this.startDateTarget.required = false
    this.endDateTarget.required = false
  }

  selectRange(e) {
    if (e) e.preventDefault()
    
    this.rangeBtnTarget.classList.add("active")
    this.singleBtnTarget.classList.remove("active")
    
    this.dateTypeTarget.value = "range"
    this.singleContainerTarget.classList.add("d-none")
    this.rangeContainerTarget.classList.remove("d-none")
    
    this.singleDateTarget.required = false
    this.startDateTarget.required = true
    this.endDateTarget.required = true
  }

  submit(event) {
    const isSingle = this.dateTypeTarget.value === "single"
    let dates = []

    if (isSingle) {
      const date = this.singleDateTarget.value
      if (!date) {
        event.preventDefault()
        alert("Please select a date.")
        return
      }
      dates.push(date)
    } else {
      const start = this.startDateTarget.value
      const end = this.endDateTarget.value

      if (!start || !end) {
        event.preventDefault()
        alert("Please select both start and end dates.")
        return
      }

      let startDate = new Date(start)
      let endDate = new Date(end)

      if (startDate > endDate) {
        event.preventDefault()
        alert("Start date must be before end date.")
        return
      }

      while (startDate <= endDate) {
        dates.push(startDate.toISOString().split('T')[0])
        startDate.setDate(startDate.getDate() + 1)
      }
    }

    this.hiddenDatesTarget.value = JSON.stringify(dates)
  }
}
